import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';

import {MapService} from '../../services/map/map.service';
import {GoogleAnalyticsService} from '../../services/googleAnalytics/google-analytics.service';
import {BookmarkService} from '../../services/bookmark/bookmark.service';

/**
 * Adds the lat/long and scale to the bottom left of the screen
 */
@Component({
  selector: 'app-coordinate',
  templateUrl: './coordinate.component.html',
  styleUrls: ['./coordinate.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CoordinateComponent implements OnInit, OnDestroy {
  private Longitude = 0;
  get longitude(): number { return this.Longitude; }

  private Latitude = 0;
  get latitude(): number { return this.Latitude; }

  private viewRefObservable;
  public mapRef;
  private mapObservable;
  public mapScale;

  constructor(private map: MapService, private ga: GoogleAnalyticsService,
              private bookmark: BookmarkService, private cd: ChangeDetectorRef) {       
    }

  ngOnInit() {
    this.viewRefObservable = this.map.getViewRefObservable().subscribe( (value) => {
      if (value) {
        this.setupCoordinateTracker();
        this.mapRef = this.map.getViewRef();
        this.bookmark.initService();
      }
    }, (error) => {
      this.ga.exception(error, false);
    });
    this.mapObservable = this.map.getMapScaleObservable().subscribe( (result) => {
      //.subscribe(() => {
        this.mapScale = result;
        //console.log('in coordinate componennt mapscale: ' + this.mapScale);
        this.cd.detectChanges();
      });
  }

  ngOnDestroy(): void {
    if (this.viewRefObservable) { this.viewRefObservable.unsubscribe(); }
    if (this.mapObservable) { this.mapObservable.unsubscribe(); }
  }

  /**
   * Sets up the view observables to keep track of the latitude, longitude and scale as a user moves around
   */
  public setupCoordinateTracker() {
    this.map.getViewRef().on('pointer-move', null, (evt) => {
      this.getCoordinates(this.map.getViewRef().toMap({ x: evt.x, y: evt.y }));
    }, (error) => {
      this.ga.exception(error, false);
    });
  }

  /**
   * Converts the latitude and longitude to a fixed decimal with toFixed
   * @param pt: The point to convert and set
   */
  private getCoordinates(pt: any) {
    if (pt && pt.latitude && pt.longitude) {
      this.Latitude = pt.latitude.toFixed(3);
      this.Longitude = pt.longitude.toFixed(3);
      this.cd.detectChanges();
    }
  }
}
